"use strict";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(generator);

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
/**
 * Collatz
 *
 * @param {*} start The number to start at
 *
 * Produces the Collatz sequence for a given start number
 * After (presumably) hitting 1, will loop infinitely on 1 -> 4 -> 2 -> 1 etc
 */
// Public API
exports.default = function (start) {
  return (0, immutable_1.Seq)(generator(start));
};
// Generator
function generator(current) {
  return regeneratorRuntime.wrap(function generator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return current;

        case 2:
          return _context.delegateYield(generator(current % 2 === 0 ? current / 2 : 3 * current + 1), "t0", 3);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}
//# sourceMappingURL=collatz.js.map


//////////////////
// WEBPACK FOOTER
// ./client/vendor/number-sequences/dist/collatz.js
// module id = 274
// module chunks = 0